import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchExerciseStatisticsArgs,
  FetchNutritionStatisticsArgs,
  FetchTrainingStatisticsArgs,
  FetchSleepStatisticsArgs,
  FetchCorrelationArgs,
  FetchTimeseriesArgs,
  FetchAggregateArgs,
  FetchCalendarArgs,
  ClientScopeArgs,
} from '../api/types/stats.types';

import {
  fetchStatsCalendar,
  fetchCorrelation,
  fetchTimeseries,
  fetchAggregate,
} from '../api/statsQuery.api';
import {
  fetchExerciseStatistics,
  fetchStrengthStatistics,
  fetchExercises,
  fetchTrainingOverview,
  fetchCardioStatistics,
} from '../api/trainingStats.api';
import { fetchNutritionStatistics } from '../api/nutritionStatistics.api';
import { fetchSleepStatistics } from '../api/sleepStats.api';

export const statsQueryQueryKeys = createQueryKeys('statsQuery', {
  fetchAggregate: (args: FetchAggregateArgs) => ({
    queryFn: () => fetchAggregate(args),
    queryKey: [args],
  }),
  fetchCalendar: (args: FetchCalendarArgs) => ({
    queryFn: () => fetchStatsCalendar(args),
    queryKey: [args],
  }),
  fetchCardioStatistics: (args: FetchTrainingStatisticsArgs) => ({
    queryFn: () => fetchCardioStatistics(args),
    queryKey: [args],
  }),
  fetchCorrelation: (args: FetchCorrelationArgs) => ({
    queryFn: () => fetchCorrelation(args),
    queryKey: [args],
  }),
  fetchExerciseStatistics: (args: FetchExerciseStatisticsArgs) => ({
    queryFn: () => fetchExerciseStatistics(args),
    queryKey: [args],
  }),
  fetchExercises: (args: ClientScopeArgs) => ({
    queryFn: () => fetchExercises(args),
    queryKey: [args],
  }),
  fetchNutritionStatistics: (args: FetchNutritionStatisticsArgs) => ({
    queryFn: () => fetchNutritionStatistics(args),
    queryKey: [args],
  }),
  fetchSleepStatistics: (args: FetchSleepStatisticsArgs) => ({
    queryFn: () => fetchSleepStatistics(args),
    queryKey: [args],
  }),
  fetchStrengthStatistics: (args: FetchTrainingStatisticsArgs) => ({
    queryFn: () => fetchStrengthStatistics(args),
    queryKey: [args],
  }),
  fetchTimeseries: (args: FetchTimeseriesArgs) => ({
    queryFn: () => fetchTimeseries(args),
    queryKey: [args],
  }),
  fetchTrainingOverview: (args: FetchTrainingStatisticsArgs) => ({
    queryFn: () => fetchTrainingOverview(args),
    queryKey: [args],
  }),
});
